import { FulfillmentOrderStatus, PickOrderStatus } from '../../../graphql'
import { StatusChipColor } from '../constants'

export const PICK_ORDER_STATUS_CHIP_COLOR: Record<PickOrderStatus, StatusChipColor> = {
	[ PickOrderStatus.Pending ]: 'warning',
	[ PickOrderStatus.Assigned ]: 'primary',
	[ PickOrderStatus.InProgress ]: 'info',
	[ PickOrderStatus.Completed ]: 'success',
	[ PickOrderStatus.Cancelled ]: 'default',
}

export const PICK_ORDER_STATUS_LABEL: Record<PickOrderStatus, string> = {
	// Nobody holds it yet, so it is work anyone at the DC can take.
	[ PickOrderStatus.Pending ]: 'Unassigned',
	// Somebody holds it but has not recorded a pick against it.
	[ PickOrderStatus.Assigned ]: 'Assigned',
	[ PickOrderStatus.InProgress ]: 'Picking',
	[ PickOrderStatus.Completed ]: 'Completed',
	[ PickOrderStatus.Cancelled ]: 'Cancelled',
}

/** A run nobody has finished or abandoned is still workable. */
export const OPEN_PICK_ORDER_STATUSES: PickOrderStatus[] = [
	PickOrderStatus.Pending,
	PickOrderStatus.Assigned,
	PickOrderStatus.InProgress,
]

export function isPickOrderTerminal( status: PickOrderStatus ): boolean {
	return status === PickOrderStatus.Completed || status === PickOrderStatus.Cancelled
}

/**
 * The statuses a fulfillment order can be in and still be picked by hand.
 *
 * Submitted, and only submitted. `_load_eligible_fulfillment_orders` rejects
 * every other status outright, so offering the action on a Pending order just
 * produces a create that cannot succeed.
 */
export const PICKABLE_FO_STATUSES: FulfillmentOrderStatus[] = [
	FulfillmentOrderStatus.SubmittedForFulfillment,
]

/**
 * How a pick order number is written wherever a person reads it.
 *
 * Deliberately not `PO-`: CostCapture uses that for purchase orders, and the
 * put-away flow already says "PO-receipt" meaning one of those. `PK-` keeps the
 * two-letter shape of its siblings (`FO-`, `WO-`) and takes its letters from
 * the word that tells a pick order and a purchase order apart.
 */
export const PICK_ORDER_PREFIX = 'PK-'

/** The guided flow's three steps, in order. */
export const PICK_ORDER_STEPS = [ 'Pick', 'Pack', 'Review' ] as const

export type PickOrderStep = typeof PICK_ORDER_STEPS[number]
